import { Component, Input, NgZone, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';
import moment from 'moment';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { mustMatch } from '../utils/app-validators';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-update-events',
  templateUrl: './update-events.component.html',
  styleUrls: ['./update-events.component.css'],
})
export class UpdateEventsComponent implements OnInit {
  @Input() status: string = 'create';
  @Input() dataObj: any;

  form: FormGroup;
  customCategory: FormArray;
  submitted = false;
  errorMessage;
  model: any;
  modelSecond: any;
  datesArray = [];
  hourArray = [];
  gallaryArr = [];
  loading = false;
  selectedItem;
  eventImage = '';
  closeResult = '';
  showImage = false;
  showDays = false;
  showhours = false;
  notifyAttendersValue = false;
  notifyvisitorsValue = false;
  baseUrl = environment.basePath;
  startTime = { hour: 0, minute: 0 };
  endTime = { hour: 0, minute: 0 };
  allAddress = '';
  eventID: any;
  eventData: any;
  defaultLocation = 'New York, NY, USA';
  constructor(
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private router: Router,
    private zone: NgZone,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe
  ) {}
  ngOnInit(): void {
    this.eventID = this.activatedRoute.snapshot.queryParamMap.get('id');
    this.getEvent();
    this.getGallary();
    // this.AddressChange(this.dataObj.address)
    this.errorMessage = environment?.errorMessage;
    this.form = this.fb.group({
      eventName: ['', Validators.required],
      description: [''],
      validFrom: ['', Validators.required],
      validTill: ['', Validators.required],
      startTime: ['00'],
      endTime: ['00'],
      photo: [''],
      address: ['', Validators.required],
      address2: [''],
      notifyVisitors: [false],
      notifyAttenders: [false],
      notifyVisitorsBefore: [''],
      notifyAttenderBefore: [''],
      accessibility: ['', Validators.required],
      role: 'Merchant',
    });
// example date
this.model = this.toNgbDateStruct(new Date('2024-11-13')); // Example start date
    this.modelSecond = this.toNgbDateStruct(new Date('2024-11-15'));

  }

  toNgbDateStruct(date: Date): NgbDateStruct {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1, // Months are 0-indexed in JavaScript
      day: date.getDate()
    };
  }

  getEvent() {
    this.authService.getMerchantEventById(this.eventID, this.eventData).subscribe(
      (res: any) => {
        this.dataObj = res.data;

        console.log("this.dataObj.validFrom>>>>>>", this.dataObj.validFrom,  moment(this.dataObj.validFrom).format("YYYY/MM/DD"))
        if (this.dataObj) {
          this.form.patchValue({
            eventName: this.dataObj.eventName || '',
            description: this.dataObj.description || '',
            validFrom: moment(this.dataObj.validFrom).format("YYYY-MM-DD") || '',
            validTill: moment(this.dataObj.validTill).format("YYYY-MM-DD") || '',
            startTime: this.dataObj.startTime || '00',
            endTime: this.dataObj.endTime || '00',
            photo: this.dataObj.photo || '',
            // address: this.dataObj.address || '',
            address2: this.dataObj.address2 || '',
            notifyVisitors: false,
            notifyAttenders: false,
            notifyVisitorsBefore: this.dataObj.notifyVisitorsBefore || '',
            notifyAttenderBefore: this.dataObj.notifyAttenderBefore || '',
            accessibility: this.dataObj.accessibility || '',
            role: this.dataObj.role || 'Merchant',
          });
        }
        console.log("this.dataObj>>>>>>>", this.dataObj)
      },
      (error) => {
        console.error('Error fetching event:', error);
      }
    );
  }

  get f() {
    return this.form.controls;
  }

  editFormData() {
    this.form.controls['description'].setValue(this.dataObj.description);
  }

  open(content) {
    this.modalService.open(content, { centered: true }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    // Extract date from the form and ignore time
    let validFrom = new Date(this.form.get('validFrom').value);
    console.log("validFrom",new Date(this.form.get('validFrom').value).toISOString());
    let validTill = new Date(this.form.get('validTill').value);

    // Reset time to midnight (00:00)
    validFrom.setHours(0, 0, 0, 0);
    validTill.setHours(0, 0, 0, 0);

    // Compare dates
    if (validFrom > validTill) {
      Swal.fire(
        '',
        'Event end date should be greater than or equal to the event start date.',
        'error'
      );
      return false;
    }
    this.authService
      .updateMerchantEvent(this.form.value, this.dataObj._id)
      .subscribe(
        (res: any) => {
          this.messageAlert(res.message, 'success');
          this.router.navigate(['/my-events']);
        },
        (error) => {
          this.messageAlert(error.error.message, 'error');
        }
      );
  }

  selectImage(props, index) {
    this.selectedItem = index;
    this.eventImage = this.checkImage(props.url);
  }
  containsHttpOrHttps(url) {
    const pattern = /^(http:\/\/|https:\/\/)/i;
    return pattern.test(url);
  }
  checkImage(image: any) {
    if (image && this.containsHttpOrHttps(image)) {
      return image;
    } else if (image && !this.containsHttpOrHttps(image)) {
      const [baseUrl, imgUrl] = image.split('uploads');
      return `https://services.ravel.faith/uploads/${imgUrl}`;
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg';
    }
  }
  renderImage(image: any) {
    if (image !== undefined || image !== null) {
      const [baseUrl, imgUrl] = image.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`;
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg';
    }
  }
  getGallary() {
    this.authService.gallery(0, 10).subscribe(
      (res: any) => {
        this.loading = true;
        this.gallaryArr = res.items;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  check(event: any, type: any) {
    if (event.target.checked && (type == 'visitors' || type == 'attendees')) {
      this.findDiff(type);
    } else {
      this.showhours = false;
      this.showDays = false;
    }
  }

  addimageForm() {
    this.showImage = true;
    this.form.get('photo').setValue(this.eventImage);
  }

  findDiff(type: string) {
    let today = new Date();

    if (this.model && this.modelSecond) {
      this.hourArray = [];

      // Combine start date and start time
      let startDateTime = moment(this.model).set({
        hour: this.form.get('startTime').value.hour,
        minute: this.form.get('startTime').value.minute,
      });

      // Combine end date and end time
      let endDateTime = moment(this.modelSecond).set({
        hour: this.form.get('endTime').value.hour,
        minute: this.form.get('endTime').value.minute,
      });

      // Calculate difference in seconds
      let diffSeconds = endDateTime.diff(startDateTime, 'seconds');
      let startEventBeforeDays = startDateTime.diff(moment(today), 'days');
      let startEventBeforehrs = startDateTime.diff(moment(today), 'hours');

      // Allow same-day events or small differences like seconds/minutes/hours
      if (diffSeconds >= 0) {
        if (type == 'attendees') {
          this.notifyAttendersValue = true;
          this.hourArray = [];
          this.showhours = true;
          this.form.get('notifyAttenders').setValue(true);

          if (startEventBeforehrs > 0) {
            for (let i = 0; i < startEventBeforehrs; i++) {
              this.hourArray.push(i + 1);
            }
          }
        } else if (type == 'visitors') {
          this.datesArray = [];
          this.showDays = true;
          this.form.get('notifyVisitors').setValue(true);

          if (startEventBeforeDays === 0) {
            this.datesArray.push(2);
          } else if (startEventBeforeDays !== 0) {
            for (let i = 0; i < startEventBeforeDays; i++) {
              this.datesArray.push(i + 1);
            }
          }
        }
      } else {
        this.authService.successMessage(
          'End date should be greater than the start date',
          'error'
        );
      }
    }
  }

  AddressChange(address: any) {
    console.log('adddress',address)
    this.dataObj.address=''
    let obj = {
      streetAddress: '',
      city: '',
      state: '',
      googleAddress: '',
      postalCode: '',
      country: '',
      suite_no: '',
      landMark: '',
      location: { type: 'Point', coordinates: [] },
    };
    this.zone.run(() => {
      this.createArray(address, obj);
    });
  }

  createArray(address: any, addressobj: any): any {
    let latitude = address.geometry?.location.lat();
    let longitude = address.geometry?.location.lng();

    // this.form.get('addressName').setValue(address.formatted_address),
    addressobj['streetAddress'] = address.formatted_address;
    addressobj['googleAddress'] = address.name ? address.name : '';
    addressobj['location'] = {
      type: 'Point',
      coordinates: [latitude, longitude],
    };

    let address_components = address?.address_components;
    for (let i = 0; i < address_components.length; i++) {
      if (address_components[i].types[0] == 'administrative_area_level_2') {
        addressobj['city'] = address_components[i].long_name || '';
      } else if (
        address_components[i].types[0] == 'administrative_area_level_1'
      ) {
        addressobj['state'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'country') {
        addressobj['country'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'postal_code') {
        addressobj['postalCode'] = address_components[i].long_name || '';
      }
    }
    this.form.controls['address'].setValue(addressobj)
    console.log("addressobj", addressobj);
    // this.allAddress = `${addressobj.streetAddress}`
    // this.form.get('address').setValue(addressobj);
    // this.form.get('address').setValue(addressobj['streetAddress']);
  }
  messageAlert(message, type) {
    this.authService.successMessage(message, type);
  }

  backEvents(){
    this.router.navigate(['/my-events']);
  }
}
